<template>
  <v-row no-gutters>
    <v-col cols="3">{{ this.scheduleDescription }} between</v-col>
    <v-col cols="3">
      <flat-pickr
        v-model="schedule.start_datetime"
        class="form-control"
        :config="config"
        style="background: white"
        placeholder="Select date and time"
        name="date"
      ></flat-pickr>
    </v-col>
    <v-col style="text-align: center">and</v-col>
    <v-col cols="3" style="text-align: center">
      <flat-pickr
        v-model="schedule.end_datetime"
        class="form-control"
        :config="config"
        style="background: white"
        placeholder="Select date and time"
        name="date"
      ></flat-pickr>
    </v-col>
  </v-row>
</template>

<script>
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import "flatpickr/dist/themes/airbnb.css";

// import constant from "../../const";

export default {
  components: {
    flatPickr,
  },
  props: ["value", "scheduleDescription"],
  data() {
    return {
      schedule: this.value || null,

      // config: {
      //   enableTime: true,
      //   dateFormat: "Y-m-d H:i:S",
      // },

      config: {
        altInput: true,
        altFormat: "M j, Y h:i K",
        altInputClass: "flatpickr-alt-input",
        enableTime: true,
        dateFormat: "Y-m-d H:i:S",
        time_24hr: true,
        position: "auto",
      },
    };
  },
  watch: {
    value() {
      this.schedule = this.value;
    },
  },

  mounted() {
    // if(this.value != null){
    //     console.log(this.schedule.start_datetime, this.schedule.end_datetime)
    //     if(this.schedule.start_datetime == null){
    //         this.schedule.start_datetime = constant.getDate(0) + ' ' + '09:00'
    //     }
    //     if(this.schedule.end_datetime == null){
    //         this.schedule.end_datetime = constant.getDate(0) + ' ' + '17:00'
    //     }
    // }
  },

  methods: {
    handleInput(e) {
      this.$emit("input", this.schedule);
    },
  },
};
</script>

<style>
.admin-dialog-container {
  padding: 0 5px;
}

.admin-dialog-container .sub-container-row-item {
  padding: 2px 10px;
}

.admin-dialog-container .sub-container-row-item .flex {
  line-height: 2.5;
}
</style>
